export const CONTACT_INFO = {
        name: "Gregg Johnson",
        title: "Software Engineering Manager",
        email: "grjohnson@gmail.com",
        linkedIn: {
            url: "https://www.linkedin.com/in/gregg-johnson-3011194",
            text: "in/gregg-johnson-3011194"
        },
        gitHub: {
            url: "https://github.com/grjohnson1",
            text: "grjohnson1"
        },
        siteName: {
            url: "https://dochano.com",
            text: "dochano.com"
        }
    };

export const EXPERIENCE_INFO = [
        {
            position: "Software Engineering Manager",
            startDate: "2022-02-28",
            endDate: "2024-12-15",
            companyName: "S&P Global",
            formerInfo: { "name": "Communify Fincentric", transitionDate: "2024-10-01" },
            list: [
                //"Established release management process that improved mulbiple technology stack deployments to under 5 minutes while reducing rollback incidents by 15%.",
                //"Scheduled weekly one-on-one goal-setting sessions with a 7-member, multi-time-zone team to enhance accountability and ensure timely SaaS application delivery.",
                //"Ran Agile ceremonies by leading sprint planning, stand-ups, velocity reviews, and retrospectives to drive efficient website development processes.",
                //"Executed comprehensive business strategy involving large migration of over 10,000 user portfolios from high-profile client's storage to internal SQL database, resulting in additional statements of work (SOW).",
                //"Collaborated with cross-functional teams (i.e. Product and Design) to define project timelines, prioritize deliverables, and identify blockers to clients' delight, resulting in additional contracts.",
                
                "Team Leadership: Scheduled weekly 1-on-1 goal-setting sessions with a 7-member, multi-time-zone team to boost accountability and ensure timely SaaS application delivery.",
                "Client Satisfaction: Executed business strategy on successfully migrating 10,000 user portfolios from client's storage to internal SQL database, resulting in additional statements of work (SOW).",
                //"Epic Envisioning: Collaborated with cross-functional teams (i.e. Product and Design) to define project timelines, prioritize deliverables, and identify blockers, resulting in additional client contracts.",
                "Strategic Planner: Created company adopted weekly cross-functional team meet-ups to pinpoint potential blockers with plenty of time to resolve without hindering other priorities.",
                "Agile Evangelist: Scrum Master in charge of leading sprint planning, stand-ups, velocity reviews, and retrospectives to drive efficient website development processes.",
                "Compliance Conscientious: Oversaw annual regulatory renewals (Sarbanes-Oxley Act - SOX, European Union's General Data Protection Regulation - GDPR, Web Accessibility - A11y), guaranteeing that digital touchpoints met stringent security, privacy, and accessibility standards.",
                
                //"Skilled Collaborator: Established weekly stakeholder meeting to surface potential blockers early which allowed for external teams to properly prioritize work.",
                //"Skilled Collaborator: Established weekly cross-functional meetings to surface potential blockers early which allowed for teams to properly prioritize work.",
                //"Compliance Leadership: Managed annual regulatory renewals (Sarbanes-Oxley Act - SOX, European Union's General Data Protection Regulation - GDPR, Web Accessibility - A11y), guaranteeing that digital touchpoints met stringent security, privacy, and accessibility standards.",
            ]
        },
        {
            position: "Software Engineering Manager",
            startDate: "2011-06-01",
            endDate: "2022-02-28",
            companyName: "IHS Markit",
            //formerInfo: { "name": "IHS Markit", transitionDate: "2012-06-12" },
            list:  [
                //"Curated template strategies to aid documentation support of high-demand APIs, similar to Quote API, to assist in scalability, reusability, and maintainability.",
                //"Improved engineering documentation processes, enabling new developers to contribute 80% faster.",
                //"Established a company-sponsored certification program in HTML5, JavaScript, and CSS3 to enhance web development standards across projects.",
                //"Led a site-wide refresh of modern technologies and designs into phases that ensured incremental delivery and continuous developer growth, meeting clients expectations.",
                //"Managed multiple React projects simultaneously roadmaps with feature flags and continous delivery strategies that reduced deployment risks by 25%.",

                //"API Development: Curated template strategies to aid documentation support of high-demand APIs, similar to Quote API, to assist in scalability, reusability, and maintainability.",
                //
                //"Team Coach: Mentored engineers transitioning into leadership roles, fostering career development and succession planning within the organization.",
                
                "Strength Builder: Increased team throughput by 25% by establishing transparent and realistic timelines that encouraged mutual accountability.",
                "Team Coach: Mentored a technical lead into their first management role.",
                "Project Orchestrator: Managed multiple client projects simultaneously roadmaps with feature flags and continuous delivery strategies that reduced deployment risks by 60%.",
                "Accelerated Integration: Improved engineering documentation processes, enabling new developers to contribute 80% faster.",
                "Technical Certification: Established a company-sponsored certification program in HTML5, JavaScript, and CSS3 to enhance web development standards across projects.",
                "Hiring Management: Enhanced prospective hire coding challenge to identify the web developer's experience level.",
                
                //"Epic Envisioning: Led a site-wide refresh of modern technologies and designs into phases that ensured incremental delivery and continuous developer growth, meeting clients expectations.",

                //"Client Satisfaction: Executed a comprehensive business strategy involving a large migration of user portfolios for high-profile clients with roughly 10,000 users from external source to internal SQL database, resulting in additional statements of work (SOW).",
                
            ]
        },
        {
            position: "Software Engineering Technical Lead",
            startDate: "2006-06-01",
            endDate: "2011-06-01",
            companyName: "Markit",
            //formerInfo: { "name": "Markit", transitionDate: "2010-06-09" },
            list: [
                //"Conducted code reviews to enforce coding standards which allowed for a 90% reduction of client off-shore QA testing.",
                //"Utilized technical experience to create a migration plan by removing project dependency and version latency to transition to cloud computing.",
                //"Customized financial services websites with tools to better present complex data, from advanced stock screeners to interactive historical price charts.",
                //"Innovative implementation of unique hash key for retrieving questionnaire answers year over year, which decreased development time by over 50%.",
                
                "Technical Resiliency: Conducted code reviews to enforce coding standards which allowed for a 90% reduction of client off-shore QA testing.",                
                //"Epic Envisioning: Led a site-wide refresh of modern technologies and designs into phases that ensured incremental delivery and continuous developer growth, meeting clients expectations.",
                "Cloud Technology: Utilized technical experience to create a migration plan by removing project dependency and version latency to transition to cloud computing.",

                "User Experience (UX) Optimization: Customized financial services websites with tools to better present complex data, from advanced stock screeners to interactive historical price charts.",
                "Roadmap Strategist: Maintained multiple client project roadmaps with feature flags and continuous delivery strategies that reduced deployment risks by 15%.",
                
                
                //"Hiring Management: Enhanced prospective hire coding challenge to identify the web developer's experience level.",
            ]
        },
        /*{
            position: "Senior Software Engineer",
            startDate: "2004-08-01",
            endDate: "2006-06-01",
            companyName: "Wall Street On Demand",
            //formerInfo: { "name": "" },
            //pagebreak: true,
            list: [
                //"Crafted and led training sessions to equip developers with proficiency in logging and performance tracking tools like Grafana and Kibana, ensuring readiness for live production incidents.",
                //"Experienced data management of variety of documents (i.e. PDF, XML,CSV, images, and videos) from CMS tools to be available via APIs or sent to users through SMS or email.",
                //"Enforced administrator roles in CMS tool to ensure proper submission, approval, and promotion process of large documents to live users.",
                //"Acted as liaison between front-end development teams to share document management skills and techniques.",
                
                //
                //"Efficiency Crusader: Streamlined production release process to under five minutes for full stack application updates.",

                "Educator: Crafted and led training sessions to equip developers with proficiency in logging and performance tracking tools like Grafana and Kibana, ensuring readiness for live production incidents.",
                "Flexible Ingenuity: Innovative implementation of unique hash key for retrieving questionnaire answers year over year, which decreased development time by over 50%.",
                "User Role Coordinator: Enforced administrator roles in CMS tool to ensure proper submission, approval, and promotion process of large documents to live users.",
                "Process Improvement: Established release management process that improved multiple technology stack deployments to under 5 minutes while reducing rollback incidents by 15%.",
                //"Cross-team Ambassador: Acted as liaison between front-end development teams to share document management skills and techniques.",
                //"Full Stack Development: Experienced data management of variety of documents (i.e. PDF, XML,CSV, images, and videos) from CMS tools to be available via APIs or sent to users through SMS or email.",
                
                //"Machine Learning Knowledge: Customized financial services websites with ML tools to help users understand complex financial data with internal branching models and event based weighted models.",
            ]
        },
        {
            position: "Software Engineer",
            startDate: "2000-08-01",
            endDate: "2004-08-01",
            companyName: "Wall Street On Demand",
            //formerInfo: { "name": "Wall Street On Demand" },
            list: [
                //"Reduced critical page performance from 1 second to under 10 milliseconds load time.",
                //"Evolved award-winning User Interface (UI) with mastery of JavaScript in developing interactive price charts for varying securities.",
                //"Pioneered front-end web development for Pocket PC at a financial firm, providing complementary devices to clients with over $1 million in trades.",
                //"Reverse Engineering: Dynamically updated XML to create a visually appealing Microsoft Excel workbook for user download, prior to helper libraries being available."
                //"Created and maintained .NET sites that securely utilized Microsoft SQL Server queries for multiple large financial research sites requiring real-time and accurate stock quote data.",
            
                "Front-end Experience: Evolved award-winning User Interface (UI) with mastery of JavaScript in developing interactive price charts for varying securities which made the top 25 Best Online Brokers list in Barron's Report.",
                "Innovative Tech: Pioneered web development for Pocket PC at a financial firm, providing complementary devices to clients with over $1 million in trades.",
                "Reverse Engineering: Dynamically updated XML to create a visually appealing Microsoft Excel workbook for user download, prior to helper libraries being available.",
                //"Continuous Learning: Used passion for learning new technologies to develop documentation to assist other developers in faster adoption.",
                "Microsoft Technology Stack: Created and maintained .NET sites that securely used Microsoft SQL Server queries for multiple large financial research sites requiring real-time and accurate stock quote data.",
            ]
        }*/
    ];

export const SKILLS = [
        //{ title: "Veteran Parent Traveler", years: 16 },
        { title: "Full Stack Developer", years: 11 },
        { title: "JavaScript", years: 11 },
        
        //{ title: "Documentation Specialist", years: 11 },
        { title: "SDLC", years: 11 },
        { title: "Software as a Service", years: 11 },
        { title: "Problem Solver", years: 11 },
        { title: "Software Manager", years: 11 },
        { title: "Product Management", years: 11 },
        { title: "Agile Development", years: 11 },
        { title: "Accessibility", years: 11 },
        { title: "Analytics Tools", years: 11 },
        //"Automated Testing",
        //"Unit Testing",
        { title: "Quality Assurance", years: 11 },
        { title: "Microsoft Suite", years: 11 },
        { title: "PowerPoint", years: 11 },
        { title: "Excel", years: 11 },
        { title: "Career Mentor", years: 10 },
        { title: "ASP Classic", years: 8 },
        { title: ".NET", years: 8 },
        { title: "Github", years: 8 },
        { title: "Jira", years: 8 },
        //{ title: "Carpool Decompressionist", years: 8 },
        { title: "VS Code", years: 7 },
        { title: "Confluence", years: 6 },
        //{ title: "Staff Sentry", years: 6 },
        //{ title: "Visionary Supporter", years: 6 },

        { title: "Software Architect", years: 5 },
        { title: "React", years: 4 },
        { title: "SQL", years: 4 },
        { title: "Cloud Computing", years: 4 },
        { title: "Figma", years: 4 },
        { title: "Ping Federate", years: 3 },
        //"SAML",
        //"JWT",
        { title: "Node", years: 2 },
        { title: "Grafana", years: 2 },
        { title: "TypeScript", years: 2 },
        { title: "Python", years: 1 },
    ];

export const ABOUT = [
    //"Results-driven Engineering Manager with a strong background in coding excellence, enhancing collaboration, and driving process efficiency. Adept at maintaining cross-functional teams, leading complex migration strategies, and improving customer satisfaction through effective communication. Passionate about continuous improvement, innovation, and championing team member growth."
    //"staff sentry", "visionary supporter", "zealous documentation specialist", "organized career mentor", "carpool decompression enthusiast", "veteran parent traveler"
    "Charismatic leader that fosters innovation allowing for teams to take on more without sacrificing quality or morale."
    ];


export const STRENGTHS = [
    {icon: "quote", title: "API Documentation", description: "Enhanced real-time Quote delivery and support for the Quote API with documentation assisting developers with troubleshooting steps, resulting in speeding up incident resolution by 20%."},
    {icon: "chart", title: "Advanced Charting", description: "Adapted various charting libraries such as Highcharts, D3.js, and Chart.js to create interactive financial data visualizations for clients, which made their way onto client commercials and news stories."},
];

export const EDUCATION = [
        {
            school: "Metropolitan State University of Denver",
            degree: "Bachelor of Science",
            program: "Computer Information Systems",
            endDate: new Date(2000, 4, 13)
        }
    ];

export const CERTIFICATES = [
        /*{
            topic: "React - The Complete Guide 2025 (includes Next.js, Redux)",
            sponsor: "Udemy"
        },
        {
            topic: "Python Playground (Second Edition)",
            sponsor: "No Starch Press",
            endDate: new Date(2025, 6, 7)
        },
        {
            topic: "Artificial Intelligence for Developers (includes Python, TensorFlow.js)",
            sponsor: "In Easy Steps Ltd.",
            endDate: new Date(2025, 5, 11)
        },
        {
            topic: "Headless CMS development",
            sponsor: "Sanity.io",
            endDate: new Date(2025, 5, 11)
        },*/
        {
            topic: "Programming in HTML5 with JavaScript and CSS3",
            sponsor: "Microsoft",
            certification: true,
            endDate: new Date(2014, 5, 15)
        }
    ];